import type { Guide } from '../types';

/**
 * S-21.10-26 — powiadomienia: stan uwagi od FTL i nowy wariant do decyzji (BR-FTL-13, FTL-09; scenariusz e2e 22).
 * Uwaga od FTL planisty przy DEMO/2026/10/007, którą CS przestawiła na „w toku” z komentarzem — dane pod slajdy
 * z 22.10.2026 (`scenario-state.mjs`); „Nowy wariant do decyzji” — z wariantów, które zakłada stan scenariuszy
 * (V01, V02, P04, 007, L01…).
 */
export const guide: Guide = {
  flagKey: 'ftlDecisionNotifications',
  title: 'Powiadomienia: stan uwagi od FTL i nowy wariant do decyzji',
  whatItDoes:
    'Gdy przyjęcie zleceń zmieni stan uwagi od FTL, autor uwagi dostaje powiadomienie imienne z nowym stanem i komentarzem — w dzwonku i na stronie powiadomień; stan końcowy nazywa się teraz „zakończona” (dotąd „załatwiona”). Nowy wariant przy zleceniu daje powiadomienie „Nowy wariant do decyzji” Team Leaderowi i autorom konkurencyjnych wariantów tego zlecenia, dopóki wariant czeka na decyzję. Własne zmiany nie dają powiadomień i nic nie wychodzi pocztą.',
  audience: ['planista FTL', 'Team Leader (planista główny)', 'przyjęcie zleceń (CS)'],
  presentationItems: ['S-21.10-26'],
  steps: [
    {
      route: '/ftl-notes',
      target: 'ftl-notes-inbox',
      title: 'Zmiana stanu uwagi z komentarzem',
      description:
        'Przyjęcie zleceń przestawia uwagę na „W toku” albo zamyka ją przyciskiem „Zakończona” (dotąd „Załatwiona”) — z komentarzem dla autora. Filtr stanu ma „W toku” i „Zakończone”.',
      action: 'Przy uwadze kliknij „W toku” albo „Zakończona” i dopisz komentarz dla autora.',
      recorder: { account: 'admin', actions: [{ kind: 'select', label: 'Stan', option: 'W toku' }] },
    },
    {
      route: '/notifications',
      target: 'history-unread',
      title: 'Powiadomienie autora uwagi',
      description:
        'Autor uwagi dostaje imienne powiadomienie: „Zmieniono stan Twojej uwagi od FTL” z nowym stanem i komentarzem — w dzwonku i na stronie powiadomień. Własne zmiany nie dają powiadomień.',
      action: 'Otwórz „Powiadomienia” i wybierz w „Rodzaj” „Zmieniono stan Twojej uwagi od FTL”.',
      recorder: {
        account: 'ftl',
        actions: [{ kind: 'select', label: 'Rodzaj', option: 'Zmieniono stan Twojej uwagi od FTL' }],
      },
    },
    {
      route: '/notifications',
      target: 'history-unread',
      title: '„Nowy wariant do decyzji” u Team Leadera',
      description:
        'Team Leader dostaje powiadomienie przy każdym nowym wariancie dodanym przez kogoś innego — z numerem pojazdu i autorem — dopóki wariant czeka na decyzję. Numer zlecenia prowadzi do karty.',
      action: 'Otwórz „Powiadomienia” i wybierz w „Rodzaj” „Nowy wariant do decyzji” albo zaznacz „Tylko moje”.',
      recorder: {
        account: 'master',
        actions: [{ kind: 'select', label: 'Rodzaj', option: 'Nowy wariant do decyzji' }],
      },
    },
    {
      route: '/notifications',
      target: 'history-unread',
      title: 'Konkurencyjny wariant u planisty',
      description:
        'Planista, który ma wariant przy zleceniu, dowiaduje się o wariancie innego planisty — powiadomienie mówi, z którym jego wariantem konkuruje.',
      action: 'Wybierz w „Rodzaj” „Nowy wariant do decyzji” i otwórz zlecenie z powiadomienia.',
      recorder: {
        account: 'ftl',
        actions: [{ kind: 'select', label: 'Rodzaj', option: 'Nowy wariant do decyzji' }],
      },
    },
  ],
};
